"use client";
import React, { createContext, useContext, useState } from 'react';

interface UserRefreshContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
}

const UserRefreshContext = createContext<UserRefreshContextType | undefined>(undefined);

export const UserRefreshProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <UserRefreshContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </UserRefreshContext.Provider>
  );
};

export const useUserRefresh = () => {
  const context = useContext(UserRefreshContext);
  if (!context) {
    throw new Error('useUserRefresh must be used within UserRefreshProvider');
  }
  return context;
};